import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import type { ModalOptions } from '@ionic/angular';
// import { CallNumber } from '@ionic-native/call-number/ngx';
// import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

import { PickupRequestModalPage } from '@shared/pages';
import { NavigationBasePage } from '@shared/pages';
import {
    GeolocationService, MapHelperService, NavigationHelperService, PickupRequestsService, PickupResponsesService,
    SummaryService
} from '@shared/services';

import type {
    TCoordinate, TCustomer, TResponse, TTicket, TShuttle, TPickupResponse, TNavigationViewModel,
    TRoutePoint, TDistance, TTimestamp, TVector
} from '@shared/models';
import { Constants } from '@shared/models';
// import { CallNumber } from 'capacitor-call-number';

// declare var self: any;
// let self: any;

@Component({
    'selector': 'app-navigation4ControlPanel',
    'templateUrl': './navigation4ControlPanel.page.html',
    'styleUrls': ['./navigation4ControlPanel.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Navigation4ControlPanelPage extends NavigationBasePage implements OnInit, OnDestroy {
    // @ViewChild('startNav') private launchGoogleMapsButton: IonButton;
    // public override vm: TNavigationViewModel = {
    //     assignedTickets: [],
    //     enrouteTickets: [],
    //     currentTickets: [],
    //     completedTickets: [],
    //     attendanceSummary: '',
    //     currentLegIdx: 0,
    //     currentLeg: undefined,
    //     currentTicket: undefined,
    //     dropoffTickets: [],
    //     myVector: undefined,
    //     numAttendees: 0,
    //     numDropoffsStr: '',
    //     numEmptySeats: 0,
    //     pickupTickets: [],
    //     route: undefined,
    //     shuttles: [],
    //     step1Complete: false,
    //     step2Complete: false,
    //     step3Complete: false,
    //     tickets: [],
    //     trip: undefined
    // };
    public vm: TNavigationViewModel = {
        assignedTickets: [],
        enrouteTickets: [],
        currentTickets: [],
        completedTickets: [],
        attendanceSummary: '',
        currentLegIdx: 0,
        currentLeg: null,
        currentTicket: null,
        distanceFromDestination: null,
        dropoffTickets: [],
        myVector: null,
        numAttendees: 0,
        numDropoffsStr: '',
        numEmptySeats: 0,
        pickupTickets: [],
        route: null,
        selectedShuttle: null,
        shuttles: [],
        step1Complete: false,
        step2Complete: false,
        step3Complete: false,
        tickets: [],
        trip: null
    };

    // public distanceFromDestination: TDistance = { 'miles': 0, 'kilometers': 0 };
    public nearAddress = '';
    public accuracy = '';
    public asOf = '';
    public isNavigationDisabled = false;
    public debugMessage = '';
    private requestsSubscription: any;
    private shuttlesSubscription: any;
    // private callNumber = new CallNumber();
    // private dropoffApproachingMiles: number;
    // private requestsStream$: FirebaseListObservable<any>;
    // private vectorsStream$: FirebaseListObservable<any>;
    // private disposable: any;
    private inPresentPickupRequest = false;

    // private callNumber: CallNumber, 
    constructor(
        private getLocationService: GeolocationService,
        private mapHelperService: MapHelperService, 
        private pickupResponsesService: PickupResponsesService,
        private summaryService: SummaryService,
        private navigationHelperService: NavigationHelperService,
        private modalCtrl: ModalController,
        private pickupRequestsService: PickupRequestsService,
        injector: Injector) {
        super(injector);
    }

    public async ionViewWillEnter(): Promise<void> {
        super.setCurrentView(this.Constants.VIEW_NAVIGATION_PAGE4);

        super.ngOnInit();
        // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE);
        this.eventsService.subscribe(Constants.EVENT_DEBUG_MESSAGE, (msg) => {
            this.onDebugMessageEvent(msg);
        });

        this.vm = super.getViewModel();

        // this.launchGoogleMapsButton.disabled = true;

        // this.dropoffApproachingMiles = (Number)(this.sessionService.getSetting().dropoffApproaching.numMilesToGo);

        // Delete all existing requests and responses for this shuttle.
        await this.pickupRequestsService.delete(this.vm.route.shuttle.uid);
        await this.pickupResponsesService.delete(this.vm.route.shuttle.uid);

        const observable = this.pickupRequestsService.getObservable();
        this.requestsSubscription = observable.subscribe((requests) => {
            // Only process requests for this shuttle.
            const request = requests.find((req) => (req.shuttleUid === this.vm.route.shuttle.uid));
            if (request) {
                this.pickupRequest(request);
            }
        });
        // super.registerSubscription(this.requestsSubscription);

        const observable2 = this.shuttlesService.getObservable();
        this.shuttlesSubscription = observable2.subscribe((shuttles) => {
            this.vectorsChange(shuttles);
        });
        // super.registerSubscription(this.vectorsSubscription);

        if (!this.sessionService.getAccountProfile().featuresInfo.campaign) {
            this.uxHelperService.showAlert('Sorry.', this.Constants.FEATURE_UPGRADE_TO_CUSTOMER_PACKAGE);
        }

        this.initMoreMenu();
    }

    // public override async ngOnInit(): Promise<void> {
    //     super.ngOnInit();
    //     // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE);
    //     this.eventsService.subscribe(Constants.EVENT_DEBUG_MESSAGE, (msg) => {
    //         this.onDebugMessageEvent(msg);
    //     });

    //     this.vm = super.getViewModel();

    //     // this.launchGoogleMapsButton.disabled = true;

    //     // this.dropoffApproachingMiles = (Number)(this.sessionService.getSetting().dropoffApproaching.numMilesToGo);

    //     // Delete all existing requests and responses for this shuttle.
    //     await this.pickupRequestsService.delete(this.vm.route.shuttle.uid);
    //     await this.pickupResponsesService.delete(this.vm.route.shuttle.uid);

    //     const observable = this.pickupRequestsService.getObservable();
    //     this.requestsSubscription = observable.subscribe((requests) => {
    //         // Only process requests for this shuttle.
    //         const request = requests.find((req) => (req.shuttleUid === this.vm.route.shuttle.uid));
    //         if (request) {
    //             this.pickupRequest(request);
    //         }
    //     });
    //     // super.registerSubscription(this.requestsSubscription);

    //     const observable2 = this.shuttlesService.getObservable();
    //     this.shuttlesSubscription = observable2.subscribe((shuttles) => {
    //         this.vectorsChange(shuttles);
    //     });
    //     // super.registerSubscription(this.vectorsSubscription);

    //     if (!this.sessionService.getAccountProfile().featuresInfo.campaign) {
    //         this.uxHelperService.showAlert('Sorry.', this.Constants.FEATURE_UPGRADE_TO_CUSTOMER_PACKAGE);
    //     }

    //     this.initMoreMenu();
    // }

    public ionViewWillLeave(): void {
        super.ngOnDestroy();
        if (this.requestsSubscription) {
            this.requestsSubscription.unsubscribe();
        }

        if (this.shuttlesSubscription) {
            this.shuttlesSubscription.unsubscribe();
        }
    }

    // public override ngOnDestroy(): void {
    //     super.ngOnDestroy();
    //     if (this.requestsSubscription) {
    //         this.requestsSubscription.unsubscribe();
    //     }

    //     if (this.shuttlesSubscription) {
    //         this.shuttlesSubscription.unsubscribe();
    //     }
    // }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tickets');
        this.supplyDebugMenuItems();
        // this.pushPopoverMenuItem('Show Tour', 'show-navigation-4-tour');
        this.moreMenuItemClick(this.handleMenuItemClick);
    }

    public onDebugMessageEvent(obj: any): void {
        const latitude = this.utilsService.round(obj.location.latitude, 6).toString();
        const longitude = this.utilsService.round(obj.location.longitude, 6).toString();
        this.debugMessage = '(' + latitude + ', ' + longitude + '); (' + obj.index + ')';
    }

    public getDebugMessage(): string {
        return this.debugMessage;
    }

    public disableTurnByTurn(): boolean {
        // const isMobileDevicethis.isNavigationDisabled = !this.sessionService.getIsMobileDevice();
        const isMobileDevice = this.sessionService.getIsMobileDevice();
        const hasCurrentLeg = !!(this.vm.currentLeg);
        const enableTurnByTurn = isMobileDevice && hasCurrentLeg;
        return !enableTurnByTurn;
    }

    public onNextClick() {
        // Do not allow moving to the next page if we still have tickets that are unprocessed.
        const idx = this.findNextEnrouteLegIdx();
        if (idx === -1) {
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/navigation/navigation5Congratulations');
        } else {
            this.uxHelperService.showAlert('Unfinished Route', 'There are still uncompleted tickets remaining.');
        }
    }

    public getNote(ticketUid: string): string {
        if (ticketUid) {
            const ticket: TTicket = this.getTicketByUid(ticketUid);
            if (ticket) {
                return ticket.note || '';
            }
        }
        return '';
    }

    private getTicketByUid(ticketUid: string): TTicket {
        // const ticket = this.vm.route.selectedTickets.find((tix: TTicket) => {
        //     return (tix.uid === ticketUid);
        // });
        // return ticket;
        const ticket = this.vm.trip.tickets.find((tix: TTicket) => (tix.uid === ticketUid));
        return ticket;
    }

    public async onMakeNextTicketCurrentClick() {
        try {
            await this.uxHelperService.showSpinner();
            this.vm.currentLegIdx = this.findNextEnrouteLegIdx();
            if (this.vm.currentLegIdx > -1) {
                this.setLegToCurrent(this.vm.currentLegIdx);
            }
            this.shuttleMovementService.setCurrentLeg(this.vm.currentLegIdx);
            // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE, this.vm);
            this.resetMoreMenu();
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    private resetMoreMenu(): void {
        if (this.vm.currentLeg) {
            this.resetPopoverMenu();
            this.pushPopoverMenuItem('Show Tickets');
            this.pushPopoverMenuItem('Call Current Passenger');
            // this.pushPopoverMenuItem('Show Tour', 'show-navigation-4-tour');
            // this.pushPopoverMenuItem('Show Navigation 4 Tour');
            this.supplyDebugMenuItems();

            this.moreMenuItemClick((menuItem: any) => {
                switch (menuItem.name) {
                    case 'Call Current Passenger':
                        this.callCurrentPassenger();
                        break;

                    default:
                        this.moreMenuItemClick(this.handleMenuItemClick);
                        break;
                }
            });
        }
    }

    // https://ionicframework.com/docs/native/call-number/
    protected async callCurrentPassenger() {
        if (this.vm.currentTicket === undefined) {
            this.uxHelperService.showAlert('Can\'t Make Call', 'Passenger Not Defined.');
            return;
        }

        try {
            const msg = `Are you sure you want to call passenger: ${this.vm.currentTicket.passengerName}?`;
            const response = await this.uxHelperService.showAlert('Confirm Call', msg);
            if (response.okay) {
                const fullname = this.vm.currentTicket.passengerName;
                const cellPhone = this.vm.currentTicket.cellPhone;
                this.capacitorService.callPrompt(cellPhone, fullname);
                // The dialer wants phone numbers in very specific format.
                // For example, convert this phone number '6618778631' into this 'tel:+16618778631'
                // const cellPhone = this.utilsService.formatPhoneNumberForDialer(this.vm.currentTicket.cellPhone);
                // const resp = await this.callNumber.callNumber(cellPhone, true)
                // const resp = await CallNumber.callNumber(cellPhone, true)
                // console.log({resp});
            }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
        // .then(() => {
        //     console.log('Dialer launched.');
        // })
        // .catch((err) => {
        //     console.error(err);
        //     this.uxHelperService.showAlert('Error', 'This device cannot make phone calls.');
        // });
    }

    // private callCurrentPassenger() {
    //     try {
    //         const fullname = this.vm.currentTicket.passengerName;
    //         const cellPhone = this.vm.currentTicket.cellPhone;

    //         this.capacitorService.callPrompt(cellPhone, fullname);
    //     } catch (err) {
    //         console.log('CallMe error: ' + err);
    //     }
    // }

    private setLegToCurrent(idx: number): void {
        try {
            const now = this.dateService.now();

            if (idx < 0 || idx > this.vm.route.routeLegs.length - 1) {
                throw Error('Error.  idx out of bounds.');
            }

            this.vm.currentLeg = this.vm.route.routeLegs[idx];
            this.vm.currentLeg.status = 'current';

            // In the case of a dropoff ticket, there will be two legs.  The first leg is dropping
            // the passenger off and there is no ticket for the return to the dealership.
            this.vm.currentTicket = null;
            if (this.vm.currentLeg.ticketUid) {
                this.vm.currentTicket = this.getTicketByUid(this.vm.currentLeg.ticketUid);

                // this.vm.currentLeg.to.address1 = this.vm.currentLeg.to.streetAddress;
                // this.vm.currentLeg.to.address2 = this.vm.currentLeg.to.city + ', ' + this.vm.currentLeg.to.zipcode;

                this.vm.currentTicket.status = 'current';
                this.vm.currentTicket.currentDate = now;
                this.ticketsService.updateTicketToCurrent(this.vm.currentTicket.uid);
                this.tripsService.updateTicket(this.vm.trip.uid, this.vm.currentTicket);

                if (!this.vm.currentTicket.fromDealership) {
                    this.sendApproachingPickupMessage();
                }
            }

            const toCoordinate = this.vm.currentLeg.to.location.address.coordinate as TCoordinate;
            this.vm.distanceFromDestination = this.utilsService.calculateDistance(
                // this.vm.myVector.currentLocation, this.vm.currentLeg.to.coordinate);
                this.vm.myVector.currentLocation, toCoordinate);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Warning', errorMessage);
        }
    }

    public getCurrentCoordinate(): string {
        const coordinate = this.vm.myVector.currentLocation;
        const str = this.utilsService.formatCoordinateForDisplay(coordinate);
        return str;
    }

    // Load GoogleMaps
    public onStartNavigationClick() {
        // this.mapHelperService.init();
        // const ticket = this.vm.route.routeLegs[this.vm.currentLegIdx];
        this.startNavigation();
    }

    // How to prevent the driver from completing the 'Return to Dealership Ticket' without being at the dealership?
    // In other words, assume 4 tickets.  3 passenger tickets and 1 'Return to Dealership' ticket.
    // The driver needs to  be able to drop off a passenger without being at the passenger's destination.
    // The passenger may say, just drop me off here at the market and I will walk the rest of the way home.
    // In this scenario the driver should drop the passenger off early, that is without being at the to coordinate.
    //
    // After the 3rd passenger has been dropped off, the next current ticket is the 'Return To Dealership' ticket.
    // Now we definitely need to complete this ticket when we are at the destination.
    //
    // Allow ticket to be completed without being at the final destination early completion???
    public async onCompleteTicketClick() {
        try {
            await this.uxHelperService.showSpinner();
            await this.sendArrivedOrCompletedMessage();
            await this.setCurrentTicketToCompleted();

            const idx = this.findNextEnrouteLegIdx();
            if (idx === -1) {
                await this.endTrip(this.vm.trip.uid);
            }
            // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE, this.vm);
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    private async endTrip(tripUid: string) {
        try {
            // super.recalculateTicketStatuses();
            this.recalculateTicketStatuses(this.vm);

            // Complete this ticket.
            this.recalculateEmptySeats();

            // Stop tracking our current location.
            this.shuttleMovementService.stopLocationTracking(this.vm.myVector);

            // 
            const totalPositions = this.shuttleMovementService.getTotalActualPositions();

            // End the trip.  Copy all the tickets with their updated times into the trip.
            // await this.tripsService.endTrip(tripUid, this.vm.route.selectedTickets);
            await this.tripsService.endTrip(tripUid, this.vm.tickets, totalPositions);

            // Make this shuttle available so that a route can be assigned to it.
            this.shuttlesService.updateShuttleToIdle(this.vm.route.shuttle.uid);

            // Reset the shuttle vector back to the ending point.
            this.shuttlesService.resetVector(this.vm.route.shuttle);

            // Go to the last navigation page.
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/navigation/navigation5Congratulations');
        } finally {
            //
        }
    }

    private findNextEnrouteLegIdx() {
        let foundIdx = -1;

        // for (let idx = 0; idx < this.vm.tickets.length; idx++) {
        // for (let idx = 0; idx < this.vm.route.selectedTickets.length; idx++) {
        for (let idx = 0; idx < this.vm.route.routeLegs.length; idx++) {
            // const ticket = this.vm.tickets[idx];
            const leg = this.vm.route.routeLegs[idx];

            // Bypass all tickets that are already completed.
            // if (ticket.status === 'enroute') {
            if (leg.status === 'enroute') {
                foundIdx = idx;
                break;
            }
        }

        return foundIdx;
    }

    private async startNavigation(): Promise<void> {
        const to: TRoutePoint = this.vm.route.routeLegs[this.vm.currentLegIdx].to;
        // const tocoordinate = this.vm.route.routeLegs[this.vm.currentLegIdx].to.coordinate as TCoordinate;
        // const locationName = this.vm.route.routeLegs[this.vm.currentLegIdx].to.locationName;
        const tocoordinate = to.location.address.coordinate as TCoordinate;
        const locationName = to.location.locationName;

        await this.mapHelperService.launchNavigationApp(tocoordinate, locationName);
    }

    // public onLaunchNavigatorSuccessCallback() {
    //     const msg = 'In NavigationPage4.onLaunchNavigatorSuccessCallback';
    //     this.uxHelperService.showAlert('Launch Navigation Success', msg);
    // }
    // public onLaunchNavigatorErrorCallback(errMsg) {
    //     // this.uxHelperService.showAlert('Launch Navigation Error', errMsg);  // this is undefined!
    //     self.uxHelperService.showAlert('Launch Navigation Error', errMsg);
    // }

    private async vectorsChange(shuttles: TShuttle[]): Promise<void> {
        if (!shuttles) {
            return;
        }
        // There are many vectors that are changing: other shuttles are driving, simulation could be running.
        // Find our current vector from among all the changed vectors.
        const vectors = await this.shuttlesService.getVectors(shuttles);
        const vects = vectors.filter((vector: TVector) => (vector.uid === this.vm.myVector.uid));
        const currentVector = (vects && vects.length > 0) ? vects[0] : null;
        if (!currentVector) {
            return;
        }

        // If this passenger has a cell phone, then potentially send the approaching dropoff message.
        // if (this.vm.currentTicket && this.vm.currentTicket.cellPhone) {
        //     const dropoffTextAlreadySent = this.vm.currentTicket.dropoffApproachingTextAlreadySent || false;
        //     if (!dropoffTextAlreadySent) {
        //         this.potentiallySendApproachingDropoffMessage(currentVector);
        //     }
        // }
    }

    /**
     * In settingDropoffMessage it specifies at which distance the dropoff message should be sent.
     * If we are closer than this distance, then send the message.
     * @param vector has information about the current location
     */
    // private async potentiallySendApproachingDropoffMessage(vector) {
    //     this.nearAddress = vector.nearAddress;
    //     this.accuracy = vector.accuracy;
    //     this.asOf = mom-ent(vector.modifiedDate).format('h:mm:ss:SSS');

    //     // let signupDateParsed = mom-ent(signupDate, 'MMMM Do YYYY, h:mm:ss a');
    //     // let signupDateFmt = signupDateParsed.format('YYYY-MM-DD');
    //     const tocoordinate = this.vm.route.routeLegs[this.vm.currentLegIdx].to.coordinate;
    //     this.distanceFromDestination = this.utilsService.calculateDistance(vector.currentLocation, tocoordinate);

    //     // 
    //     if (this.distanceFromDestination.miles < this.dropoffApproachingMiles) {
    //         const messageSentDate: any = await this.sendApproachingDropoffMessage();
    //         this.vm.currentTicket.dropoffApproachingTextAlreadySent = true;

    //         // Keep track of when we sent out the take belongings message.
    //         const ticket = await this.ticketsService.getByUid(this.vm.currentTicket.uid);
    //         ticket.takeBelongingsDate = messageSentDate;
    //         this.ticketsService.update(ticket);
    //     }
    // }

    private sendApproachingDropoffMessage(): TTimestamp {
        let sentDate: TTimestamp = this.dateService.getMinimumDate();

        try {
            const customer: TCustomer = this.buildCustomerFromCurrentTicket();
            if (customer) {
                const customers: TCustomer[] = [customer];

                this.eventsService.publish(Constants.EVENT_APPROACHING_DROPOFF, customers);
                sentDate = this.dateService.now();
            }
            return sentDate;
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
            return sentDate;
        }
    }

    private sendApproachingPickupMessage(): TTimestamp {
        let sentDate: TTimestamp = this.dateService.getMinimumDate();

        try {
            const customer: TCustomer = this.buildCustomerFromCurrentTicket();
            if (customer) {
                const tocoordinate = this.vm.currentLeg.to.location.address.coordinate;
                const data = { 'customers': [customer], 'tocoordinate': tocoordinate };

                this.eventsService.publish(this.Constants.EVENT_APPROACHING_PICKUP, data);

                sentDate = this.dateService.now();
            }
            return sentDate;
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
            return sentDate;
        }
    }

    private sendArrivedOrCompletedMessage(): TTimestamp {
        let sentDate: TTimestamp = this.dateService.getMinimumDate();

        try {
            if (!this.vm.currentTicket) {
                return sentDate;
            }

            const fromDealership = this.vm.currentTicket.fromDealership;
            const customer: TCustomer = this.buildCustomerFromCurrentTicket();
            if (customer) {
                const customers: TCustomer[] = [customer];
                const data = { 'customers': customers };

                if (fromDealership) {
                    // sentDate = await this.firebaseFunctionsService.sendDropoffCompleteMessage(customers);
                    this.eventsService.publish(this.Constants.EVENT_DROPOFF_COMPLETED, data);
                } else {
                    // const here = this.vm.myVector.currentLocation;
                    // const destinationCoordinate = this.vm.currentLeg.to.coordinate;
                    // const delta = 
                    if (this.vm.distanceFromDestination.miles < 0.1) {
                        this.eventsService.publish(this.Constants.EVENT_PICKUP_ARRIVED, data);
                    } else {
                        this.eventsService.publish(this.Constants.EVENT_PICKUP_COMPLETED, data);
                    }
                    // send pickup_arrived or pickup_completed message.
                    // How can I tell which message to send?  Do I look at the passenger name and then look at
                    // the next ticket to get the customer info? 
                    // this.eventsService.publish(this.Constants.EVENT_PICKUP_COMPLETED, data);
                    // sentDate = await this.firebaseFunctionsService.sendThankYouMessage(customers);
                }

                sentDate = this.dateService.now();
            }
            return sentDate;
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
            return sentDate;
        }
    }

    private buildCustomerFromCurrentTicket() {
        if (!this.vm.currentTicket || !this.vm.currentTicket.passengerName || !this.vm.currentTicket.cellPhone) {
            return null;
        }

        const customer: TCustomer = {
            'customerName': this.vm.currentTicket.passengerName,
            'cellPhone': this.vm.currentTicket.cellPhone,
            'uid': null,
            'shuttleDates': []
        };
        return customer;
    }

    private async setCurrentTicketToCompleted(): Promise<void> {
        if (this.vm.currentTicket) {
            this.vm.currentTicket.status = 'completed';
            this.vm.currentTicket.completedDate = this.dateService.now();

            await this.tripsService.updateTicket(this.vm.trip.uid, this.vm.currentTicket);

            await this.ticketsService.updateTicketToCompleted(this.vm.currentTicket.uid);

            this.vm.currentTicket = null;
            this.vm.currentLeg = null;
        }
    }

    private recalculateEmptySeats() {
        let numSeatsAvailable = this.vm.route.shuttle.passengerCapacity;

        let idx = this.vm.currentLegIdx;
        do {
            if (idx < this.vm.tickets.length - 1) {
                const ticket = this.vm.tickets[idx];
                numSeatsAvailable -= ticket?.numPassengers;
            }
            idx = this.findNextEnrouteLegIdx();
        } while (idx !== -1);
        this.vm.numEmptySeats = numSeatsAvailable;
    }

    // Prompt the driver if he would like to accept this ticket.
    public async pickupRequest(request) {
        const requestUid = request.uid;
        const shuttleUid = request.shuttleUid;
        const ticket = request.ticket;

        // When this.modalCtrl.create(options) is called, it somehow calls presetPickupRequest.
        // So, prevent two dialogs from appearing.
        if (this.inPresentPickupRequest) {
            return;
        }

        // Alert the driver that he needs to respond to the dialog by playing a tune.
        this.uxHelperService.playPickupAlert();
        const accept: any = await this.presentPickupRequest(ticket);
        this.uxHelperService.stopSound();

        // Build the response.
        const response: TPickupResponse = {
            'shuttleUid': shuttleUid, 'ticketUid': ticket.uid, 'ticket': ticket,
            'requestUid': requestUid, 'accepted': accept, 'uid': shuttleUid
        };

        // Let the pickupQueue service know of our decision.
        await this.pickupResponsesService.delete(shuttleUid);
        await this.pickupResponsesService.set(response);

        // If we accepted this pickup, then insert this ticket into our route and update route.routeLegs.
        if (accept) {
            const insertTicketPos = await this.navigationHelperService.insertTicketIntoRoute(this.vm, ticket);
            if (insertTicketPos === 0) {
                this.setLegToCurrent(insertTicketPos);
            }
            // this.startNavigation();
        }
    }

    private async presentPickupRequest(ticket: TTicket) {
        // When this.modalCtrl.create(options) is called, it somehow calls presetPickupRequest.
        // So, prevent two dialogs from appearing.
        if (this.inPresentPickupRequest) {
            return;
        }

        this.inPresentPickupRequest = true;
        const data = { 'ticket': ticket };
        const options: ModalOptions = {
            'component': PickupRequestModalPage,
            'componentProps': data,
            'backdropDismiss': false,
            'showBackdrop': true,
            'cssClass': 'myModalSize'
        };

        const myModal = await this.modalCtrl.create(options);
        await myModal.present();
        const response = await myModal.onDidDismiss();
        this.inPresentPickupRequest = false;
        return response.data.accept;
    }
}
